import {useState} from 'react'
import {Button, Flash, Link} from '@primer/react'
import {announce} from '@github-ui/aria-live'
import {useDequeuePullRequestMutation} from '../../hooks/mutations/use-dequeue-pull-request-mutation'
import {useSidebarMergeData} from './use-sidebar-merge-data'

export function SidebarQueuedState() {
  const {mergeBoxPullRequest} = useSidebarMergeData()
  const mergeQueueEntry = mergeBoxPullRequest?.mergeQueueEntry
  const mergeQueue = mergeBoxPullRequest?.mergeQueue ?? null
  const viewerCanAddAndRemoveFromMergeQueue = mergeBoxPullRequest?.viewerCanAddAndRemoveFromMergeQueue ?? false

  const [errorMessage, setErrorMessage] = useState<string>()
  const {mutate: dequeuePullRequest, isPending: isDequeuing} = useDequeuePullRequestMutation({
    onError: (e: Error) => {
      setErrorMessage(e.message)
      announce(e.message)
    },
  })

  if (!mergeQueueEntry) return null

  const pullsAhead = mergeQueueEntry.position - 1
  const queuePositionPrefix =
    pullsAhead === 0
      ? 'This pull request is next up in the '
      : `There ${pullsAhead === 1 ? 'is 1 pull request' : `are ${pullsAhead} pull requests`} ahead in the `

  return (
    <div className="d-flex flex-column gap-2 pt-2">
      {errorMessage && <Flash variant="danger">{errorMessage}</Flash>}
      {viewerCanAddAndRemoveFromMergeQueue && !mergeQueueEntry.isLocked && (
        <Button
          block
          variant="danger"
          loading={isDequeuing}
          loadingAnnouncement="Removing from queue"
          onClick={() => {
            setErrorMessage(undefined)
            dequeuePullRequest()
          }}
        >
          Remove from queue
        </Button>
      )}
      <span className="text-small color-fg-muted">
        {mergeQueue ? (
          <>
            <span>{queuePositionPrefix}</span>
            <Link href={mergeQueue.url} inline>
              merge queue
            </Link>
            <span>.</span>
          </>
        ) : (
          `${queuePositionPrefix}merge queue.`
        )}
      </span>
    </div>
  )
}
